import { IRigCost } from '../../interfaces/irig-cost';
import { Rig } from '../rig';
import { RigCostType } from '../rig-cost-type';
import { UnitOfMeasure } from '../unit-of-measure';

export class RigCostBase {
  RigCostId: number;
  RigId: number;
  RigCostTypeId: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  Daily: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  RigCostType?: RigCostType;
  Rig?: Rig;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IRigCost) {
    if (item) {

      this.RigCostId = item.RigCostId;
      this.RigId = item.RigId;
      this.RigCostTypeId = item.RigCostTypeId;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Daily = item.Daily;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.RigCostType = new RigCostType(item.RigCostType);
      this.Rig = new Rig(item.Rig);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}